<app-reservation-view [isRecurring]="false"></app-reservation-view>
